import { type InboxEntry, InboxEntrySource } from '@this+that/models';

import { isFreshInsert, isOpen } from './entryInsertPredicates';

interface SuggestionViewer {
  userId?: string | null;
  defaultTaskGroupId?: string | null;
}

const isAgentSuggestion = (entry: InboxEntry) =>
  entry.isSuggestion === true && entry.source === InboxEntrySource.AGENT;

export function isQualifyingSuggestionInsert(
  entry: InboxEntry,
  { userId, defaultTaskGroupId }: SuggestionViewer,
): boolean {
  if (!userId || !defaultTaskGroupId) return false;
  return (
    isAgentSuggestion(entry) &&
    entry.taskGroupId === defaultTaskGroupId &&
    entry.createdFor === userId &&
    isFreshInsert(entry) &&
    isOpen(entry)
  );
}
